export var dataHooks = {
  checkboxText: 'checkbox-text'
};